import React, { Component } from 'react'
import 'react-datepicker/dist/react-datepicker.css'
import './DateSelectorInput.scss'
import Field from '../Field/Field'
import PropTypes from 'prop-types'

class DateSelectorInput extends Component {
  state = {
    focusOnSuggestedDate: false,
  }

  handleOnKeyDown = event => {
    const { key } = event
    const {
      suggestedDate: { stringifiedDate, date },
      setSuggestedDate,
    } = this.props
    switch (key) {
      case 'ArrowDown':
        if (stringifiedDate) {
          event.preventDefault()
          this.setState({ focusOnSuggestedDate: true })
        }
        break
      case 'Enter':
        if (date) {
          setSuggestedDate(date)
        }
        break
      default:
        break
    }
  }

  render() {
    const {
      label,
      selected,
      onClick,
      isChecked,
      hasCheckbox,
      handleCheckboxClick,
      disabled,
      handleType,
      inputVal,
      inputId,
      setSuggestedDate,
      suggestedDate,
    } = this.props
    return (
      <React.Fragment>
        <Field
          autoComplete
          label={label}
          placeholder={selected}
          handleClick={onClick}
          handleOnKeyDown={this.handleOnKeyDown}
          icon="calendar"
          isChecked={isChecked}
          hasCheckbox={hasCheckbox}
          handleCheckboxClick={handleCheckboxClick}
          disabled={disabled}
          handleType={e => handleType(e, inputId)}
          key={'field' + label}
          value={inputVal}
        />
        {suggestedDate.stringifiedDate && (
          <span
            data-focused={this.state.focusOnSuggestedDate}
            className="datePicker__listWrapper"
            onClick={() => setSuggestedDate(suggestedDate.date)}
            onKeyDown={this.handleOnKeyDown}
          >
            {suggestedDate.stringifiedDate}
          </span>
        )}
      </React.Fragment>
    )
  }
}

DateSelectorInput.propTypes = {
  inputId: PropTypes.string,
  onClick: PropTypes.func,
  value: PropTypes.string,
  label: PropTypes.string,
  selected: PropTypes.string,
  hasCheckbox: PropTypes.bool,
  isChecked: PropTypes.bool,
  handleCheckboxClick: PropTypes.func,
  disabled: PropTypes.bool,
  handleType: PropTypes.func,
  suggestedDate: PropTypes.object,
  setSuggestedDate: PropTypes.func,
  inputVal: PropTypes.string,
}

export default DateSelectorInput
